export const blockIconsSocialWaterDropNew = (
	<span className='material-symbols-outlined'>water_drop</span>
);
